module.exports = __webpack_public_path__ + "static/media/okr.7fd58ec2.jpeg";